
import GoodsAccountImg from '@/components/GoodsBox/GoodsAccountImg'
import GoodsListPage from '@/components/GoodsListPage'
import { mapGetters } from 'vuex'
import { convert2GameConfig, getCatalogueId } from './generalGoodsUtils'
import { recoverExternal, formatParams, recover } from '@/components/BuyGoodsList/fast/useRecover'

const ListLoading = () => import('@/components/ListLoading')
const GoodsAccountGeneralItem = () => import('@/components/GoodsBox/GoodsAccountGeneralItem')

// 缓存成品号的GameConfig serverTree
const cache = {}

import { formatCount } from '@/utils'
const GoodsAccountText = () => import('@/components/GoodsBox/GoodsAccountText')
import { handleFkOutLink } from '@/utils/fk'
export default {
	components: {
		GoodsAccountImg,
		GoodsListPage,
		ListLoading,
		GoodsAccountGeneralItem
	},
	async asyncData({ app, route, params, query, store }) {
		try {
			async function getTabs() {
				const { data } = await app.$api.getGeneralGoodsCateItems({
					gameId: params.gameId
				})
				return data
			}

			const data = await getTabs()
			const topTabs =
				data?.map(item => ({
					...item,
					name: item.catalogueId,
					label: item.catalogueName
				})) || []

            let goodsCatalogueId = ''
            if (query?.goodsCatalogueId && topTabs.find(item => item.name === Number(query.goodsCatalogueId))) {
                goodsCatalogueId = Number(query.goodsCatalogueId)
            } else {
                goodsCatalogueId = topTabs[0]?.name
            }

			async function getGameConfig() {
				const data = {
					action: {
						gameId: params.gameId,
						goodsCatalogueId,
						inSell: true,
						search: true
					}
				}
				const res = await app.$api.listGoodsPropertyConfigBySearch(data)
				return res.data
			}

            async function getServerTree() {
                const data = {
                    action: {
                        gameId: params.gameId,
                        goodsCatalogueId
                    }
                }
                const res = await app.$api.treeGameProperTiesBySearch(data)
                return res.data
            }

            async function getGoodsOptions() {
				const api = app.$api
				const gameId = params.gameId

                const data = {
                    gameId,
                    goodsCatalogueId,
                    search: true,
                    inSell: true
                }

                const res = await api.getGeneralGoodsOptions(data)
                return res?.data?.list
            }

            async function getGeneralServerTree() {
                const data = {
                    action: {
                        gameId: params.gameId,
                        goodsCatalogueId
                    }
                }
                const res = await app.$api.getGeneralGoodsCateTree(data)
                return res.data
            }

			async function getGoodsFirstList() {
				const data = {
					action: {
						gameId: params.gameId,
						goodsCatalogueId,
						keywords: [],
						searchWords: params.keyReason ? [params.keyReason] : [],
						merchantMark: params.merchantMark || query.merchantMark || null
					},
					sort: null,
					order: null,
					page: 1,
					pageSize: 21
				}
				if (store.state.game.recommendFilter) {
					data.action[store.state.game.recommendFilter] = true
				}
                const apiMethod = isGeneralGoods ? 'getGeneralList' : 'goodsList'
				const res = await app.$api[apiMethod](data)
				// 去重
				res.data.records = res.data.records.filter((item, index, self) => self.findIndex(t => t.goodsNo === item.goodsNo) === index)
				return res.data
			}

			async function getCurrentGameName() {
				const data = {
					action: {
						gameId: params.gameId,
						goodsCatalogueId: 6
					}
				}
				const res = await app.$api.gameAll(data)
				return res.data[0].name
			}

			async function getBanner() {
				const bannerInfo = await app.$api.bannerGoodsMore({
					action: {
						gameCatalogueId: params.gameCatalogueId,
						gameId: params.gameId,
						goodsCatalogueId: 6
					}
				})
				return bannerInfo.data
			}

            const currentTab = topTabs?.find(item => item.name === goodsCatalogueId) || null
            const isGeneralGoods = currentTab?.catalogueCode !== "NORMAL_GOODS"

            let serverTree = [], gameConfig = [], filterOriginData = []
            // 非成品号请求这两个接口
            if (!isGeneralGoods) {
                serverTree = await getServerTree()
                gameConfig = await getGameConfig()
                filterOriginData = await getGoodsOptions()
            } else {
                serverTree = await getGeneralServerTree()
                const filterOriginDataGeneral = await getGoodsOptions()
                const { itemsGameConfig, filterOriginData: filterOriginDataRename } = convert2GameConfig(currentTab?.items, filterOriginDataGeneral);
                filterOriginData = [...filterOriginDataGeneral, ...filterOriginDataRename];
                gameConfig = itemsGameConfig;
            }

			const bannerImgs = await getBanner()

			const gameName = await getCurrentGameName()

			const goodsListPage = await getGoodsFirstList()

			return {
				searchWords: '',
				page: 1,
				pageSize: 21,
				goodsTotalNum: Number(goodsListPage.total),
				// /**
				//  * 已整理
				//  */
				bannerImgs,
				goodsList: goodsListPage.records,
				gameName,
				gameConfig,
				serverTree,
				//
				searchInfo: {
					keywords: params.keyReason ? [params.keyReason] : []
				},
				// seo数据
				seoData: {
					BAIDU_URL: process.env.BAIDU_URL + route.path,
					BAIDU_DATE: app.$formattedDateTime(),
					BAIDU_PUSH_DATE: goodsListPage.records.length > 0 ? goodsListPage.records[0]?.onStandTime.replace(' ', 'T') : '',
					gameName: gameName
				},
                topTabs,

                filterOriginData,
                goodsCatalogueId,
			}
		} catch (error) {
			console.log(error)
		}
	},
	data() {
		return {
			showImg: false, //显示昨日成交图片
			keyReason: null, // header 传递的搜索词
			filter: {},
            goodsSearchActions:{},
			filterSearchPropertyIds: {},
			sort: null,
			sortName: '',
			order: 'ASC',
			searchWords: '', // 搜索词 有的话会覆盖keyReason
			page: 1,
			pageSize: 21,
			goodsTotalNum: 0,
			datalist: [],
			//
			bannerImgs: [],
			goodsList: [],
			gameConfig: [],
			serverTree: [],
			gameName: '',
			//
			loading: false,
			searchInfo: {
				keywords: []
			},

			topTabs: [],
			goodsCatalogueId: '',

			// 文字/图片显示模式
			switchText: false,
			seoData: {},

            filterOriginData: [],
            latestExtraFilter: {}
		}
	},
	computed: {
		...mapGetters({
			userinfo: 'user/userinfo',
			recommendFilter: 'game/recommendFilter'
		}),
        currentTab() {
            return this.topTabs?.find(item => item.name === this.goodsCatalogueId) || null
        },
        isGeneralGoods(){
            const isGeneralGoods = this.currentTab?.catalogueCode !== "NORMAL_GOODS"
            return isGeneralGoods
        }
	},
	watchQuery: ['page'],
	methods: {
		/**
		 * new
		 */
		getYerstDayStatus() {
			this.$api.dealGameStatusAPI({ gameId: this.$route.params.gameId }).then(res => {
				if (res.success) {
					this.showImg = true
				}
			})
		},
		onClickBanner(item) {
			const info = {
				action: {
					event: 'GOODS_LIST_BANNER',
					eventId: item.id
				}
			}
			this.$api.getRelatedClicks(info).then(res => {
				if (res.success) {
					switch (item.jumpType) {
						case ' NONE':
							break
						case 'OUT_LINK':
							window.open(item.jumpAddr)
							break
						case 'GOODS_LIST':
							this.$store.commit('game/SET_BUY_GOODS_TYPE', 6)
							this.$router.push({
								name: 'goodsList',
								params: {
									gameId: item.gameId,
									goodsCatalogueId: 6
								},
								query: {
									page: 1
								}
							})
							break
						case 'BUSINESS_ARTICLE':
							this.$router.push(`/business/${item.jumpAddr}`)
							break
						case 'GOODS_DETAIL':
							this.$router.push({
								name: 'goodsDetails',
								params: {
									goodsNo: item.jumpAddr,
									goodsCatalogueId: 6
								}
							})
							break
						case 'FKHD':
							handleFkOutLink(item.jumpAddr, this)
							break
					}
				}
			})
		},
		async getGoodsList() {
			this.loading = true
			const keywords = []
			const _searchWords = []
			const unionGameIds = []
			const _goodsSearchActions = []
			let searchWordsStr = this.searchWords || this.keyReason || null
			if (searchWordsStr) _searchWords.push(searchWordsStr)
            // console.log(this.goodsSearchActions ,'这里是搜索的数据');
            if (Object.keys(this.goodsSearchActions).length) {
				for (const key in this.goodsSearchActions) {
					if (key === 'unionGameIds') {
						unionGameIds.push(...this.goodsSearchActions[key].searchList)
					} else {
						_goodsSearchActions.push(this.goodsSearchActions[key])
					}
				}
			}

			const searchPropertyIds = []
			if (Object.keys(this.filterSearchPropertyIds).length) {
				for (const key in this.filterSearchPropertyIds) {
					if (this.filterSearchPropertyIds[key]) searchPropertyIds.push(...this.filterSearchPropertyIds[key])
				}
			}

			const goodsCatalogueId = getCatalogueId(this.filter, this.isGeneralGoods, this.goodsCatalogueId)

            const filterParams = formatParams(this.filter, this.isGeneralGoods)

			const data = {
				order: this.order,
				sort: this.sort,
				page: this.page,
				pageSize: this.pageSize,
				action: {
					gameId: this.$route.params.gameId,
					merchantMark: this.$route.query.merchantMark || null,
					keywords,
					searchWords: _searchWords,
					searchPropertyIds,
					unionGameIds,
					goodsSearchActions: _goodsSearchActions,
					...filterParams,
					// goodsCatalogueId 不能移动
					goodsCatalogueId
				}
			}
			// 记录searchWordsStr
			this.searchInfo.keywords = _searchWords

			const apiMethod = this.isGeneralGoods ? 'getGeneralList' : 'goodsList'

			const res = await this.$api[apiMethod](data)

			this.loading = false

			if (!res.success) {
				this.$message.error(res.info)
				return
			}
			this.goodsList = res.data.records.filter((item, index, self) => self.findIndex(t => t.goodsNo === item.goodsNo) === index)
			this.goodsList.forEach(item => {
				item.page = data.page
			})
			this.goodsTotalNum = Number(res.data.total)
		},
        // 非成品号商品分类树
        async getGameConfig() {
            const { goodsCatalogueId } = this
            const data = {
                action: {
                    gameId: this.$route.params.gameId,
                    goodsCatalogueId,
                    inSell: true,
                    search: true
                }
            }
            const res = await this.$api.listGoodsPropertyConfigBySearch(data)
            return res.data
        },
        // 非成品号服务器大区
        async getServerTree() {
            const { goodsCatalogueId } = this
            const data = {
                action: {
                    gameId: this.$route.params.gameId,
                    goodsCatalogueId
                }
            }
            const res = await this.$api.treeGameProperTiesBySearch(data)
            return res.data
        },
        async getGoodsOptions() {
            const api = this.$api
            const gameId = this.$route.params.gameId

            const data = {
                gameId,
                goodsCatalogueId: this.goodsCatalogueId,
                search: true,
                inSell: true
            }

            const res = await api.getGeneralGoodsOptions(data)
            return res?.data?.list
        },
        async getGeneralServerTree() {
            const data = {
                action: {
                    gameId: this.$route.params.gameId,
                    goodsCatalogueId: this.goodsCatalogueId,
                }
            }
            const res = await this.$api.getGeneralGoodsCateTree(data)
            return res.data
        },
		// 曝光埋点
		handleExposure(goodsCatalogueName) {
			this.$trackEvent({
				eventType: 'pageView',
				trackParams: {
					eventName: '商列-商品列表页浏览',
					goodsCatalogueName
				}
			})
		},
        onTabChange(item) {
			this.$trackEvent({
				eventType: 'click',
				trackParams: {
					eventName: '交易品Tab点击',
					buttonName: item.label,
					gameId: this.$route.params.gameId
				}
			})
			this.handleExposure(item.label)
            const goodsCatalogueId = item.name
            this.goodsCatalogueId = goodsCatalogueId

            this.$store.commit('filter/SET_IS_GENERAL_GOODS', item.catalogueCode !== "NORMAL_GOODS")

            this.clearTabFilter()
            this.fetchTabData(item)
            this.onFilterChange()
		},
        // 清空筛选项
        clearTabFilter() {
            this.filter = {}
            this.goodsSearchActions = {}
            this.filterSearchPropertyIds = {}
            // this.searchWords = ''
            this.sort = null
            this.order = 'ASC'
            this.pageSize = 21
            this.goodsTotalNum = 0
        },
        setGoodsListParams() {
            recover(this)
        },
        async fetchTabData(item) {
            const goodsCatalogueId = item.name

            console.log(item, '这里是item');

            // 成品号-游戏配置/分类树/属性选项
            if (item.catalogueCode === "NORMAL_GOODS") {
                if (!cache[goodsCatalogueId]?.filterOriginData) {
                    this.filterOriginData = []
                    this.gameConfig = []
                    this.serverTree = []

                    this.serverTree = await this.getServerTree()
                    this.gameConfig = await this.getGameConfig()
                    this.setGoodsListParams()
                    this.filterOriginData = await this.getGoodsOptions();
                    this.setGoodsCache()
                    return
                }
                this.gameConfig = cache[goodsCatalogueId].gameConfig
                this.serverTree = cache[goodsCatalogueId].serverTree

	            // 成品号 恢复fastFilter的筛选条件
                this.setGoodsListParams()
                this.filterOriginData = cache[goodsCatalogueId].filterOriginData
                return;
            }

            // 非成品号-属性选项 和 游戏配置
            if (!cache[goodsCatalogueId]?.filterOriginData) {
                this.filterOriginData = []
                this.gameConfig = []
                this.serverTree = []

                const serverTree = await this.getGeneralServerTree()
                const filterOriginDataGeneral = await this.getGoodsOptions();

                const { itemsGameConfig, filterOriginData } = convert2GameConfig(item.items, filterOriginDataGeneral);
                const gameConfig = itemsGameConfig;
                this.filterOriginData = [...filterOriginDataGeneral, ...filterOriginData];
                this.gameConfig = gameConfig;
                this.serverTree = serverTree;
                this.setGoodsCache()
            } else {
                this.filterOriginData = cache[goodsCatalogueId].filterOriginData
                this.gameConfig = cache[goodsCatalogueId].gameConfig
                this.serverTree = cache[goodsCatalogueId].serverTree
            }
        },
        updateLatestFilter(key, data) {
            // if (!fastFilterRef.value.filterCount) {
            //     return
            // }
            // this.latestExtraFilter[key] = data
            this.$set(this.latestExtraFilter, key, data)
            this.$store.dispatch('filter/updateLatestFilter', {
                gameId: this.$route.params.gameId,
                key,
                data
            })
        },
        onUpdateSort(e, isUpdateLatest = true) {
            this.sort = e
            if (isUpdateLatest) {
                this.updateLatestFilter('sort', {
                    sort: this.sort,
                    order: this.order,
                    sortName: this.sortName
                })
            }
        },
        onUpdateOrder(e, isUpdateLatest = true) {
            this.order = e
            if (isUpdateLatest) {
                this.updateLatestFilter('sort', {
                    sort: this.sort,
                    order: this.order,
                    sortName: this.sortName
                })
            }
        },
        onQuickChange(type, data) {
            if (type === 'filterSearchPropertyIds') {
                this.updateLatestFilter('filterSearchPropertyIds', data)
            }
            else if (type === 'quickField') {
                this.updateLatestFilter('quickField', data)
            }
            else if (type === 'server') {
                this.updateLatestFilter('server', data)
            }
        },
		// filter 变化
		onFilterChange(item) {
			this.page = 1
			this.getGoodsList()
			if (item?.propertyName) {
				this.$trackEvent({
					eventType: 'click',
					trackParams: {
						eventName: '商列-推荐筛选点击',
						gameId: this.$route.params.gameId,
						name: item.propertyName
					}
				})
			}
		},
        onReSearch(filterData) {
            recoverExternal({
                filterData,
                that: this
            })
        },
		// 页数 变化
		onPageChange(val) {
			this.page = val
			document?.querySelector('#app').scrollIntoView()
			this.getGoodsList()
			return
		},
		// 每页数量变化
		onPageSizeChange(val) {
			this.pageSize = val
			this.getGoodsList()
			return
        },
        abTrack() {
            window.collectEvent('product_list_view', { is_new_user: this.userinfo?.isAbUser ? "1" : "0" })
        },
        setGoodsCache() {
            const { goodsCatalogueId, gameConfig, serverTree, filterOriginData } = this;
            (cache[goodsCatalogueId] || (cache[goodsCatalogueId] = {})).filterOriginData = filterOriginData;
            (cache[goodsCatalogueId] || (cache[goodsCatalogueId] = {})).gameConfig = gameConfig;
            (cache[goodsCatalogueId] || (cache[goodsCatalogueId] = {})).serverTree = serverTree;
        },
        setDefaultWantAndSeenNum() {
            this.goodsList.forEach(item => {
                item.wantNum = 0
                item.seenNum = 0
                item.wantBuyText = formatCount(item.wantNum)
                item.seenText = formatCount(item.seenNum)
            })
        },
        async getWantAndSeenNum(goodsNoList) {
            try{
                const data = { action: [...goodsNoList] }
                const res = await this.$api.getGoodsWantAndSeenNum(data)
                if(res.success && res?.data?.length){
                    const map = new Map(res.data.map(d => [d.goodsNo, d]))
                    this.goodsList.forEach(item => {
                        const numItem = map.get(item.goodsNo)
                        if(numItem){
                            this.$set(item, 'wantNum', numItem.wantNum || 0)
                            this.$set(item, 'seenNum', numItem.seenNum || 0)
                            this.$set(item, 'wantBuyText', formatCount(numItem.wantNum || 0))
                            this.$set(item, 'seenText', formatCount(numItem.seenNum || 0))
                        }
                    })
                    this.goodsList = [...this.goodsList]
                }else{
                    this.setDefaultWantAndSeenNum()
                }
            }catch(err){
                this.setDefaultWantAndSeenNum()
            }
        }
	},
	async mounted() {
		this.handleExposure(this.currentTab?.label || '成品号')
        this.setGoodsCache()

		if (this.recommendFilter) {
			this.filter[this.recommendFilter] = true
		}
		if (this.$route.params.keyReason) {
			this.keyReason = this.$route.params.keyReason
		}

		if (process.client) {
			this.switchText = window.localStorage.getItem('switchText') === 'true'
		}
        if(this.goodsList.length){
            await this.getWantAndSeenNum(this.goodsList.map(item => {return {goodsNo:item.goodsNo,onStandTime:item.onStandTime}}))
        }
        this.getYerstDayStatus();
        this.abTrack();
		this.$store.dispatch('user/UserCenterStatistics')
	},
	head() {
		if (!this.$config.isPublicProd) return {}
		return {
			title: `${this.seoData.gameName}游戏账号交易平台_${this.seoData.gameName}账号购买-${this.page > 1 ? '第' + this.page + '页-' : ''}盼之代售-手游网游账号买号卖号平台`,
			meta: [
				{
					//
					hid: 'description',
					name: 'description',
					content: `盼之代售${this.seoData.gameName}交易平台，是专业的游戏账号交易平台，提供正规安全的${this.seoData.gameName}账号买卖等服务，安全便捷，找回包赔，更多账号交易尽在盼之代售`
				},

				{
					hid: 'keywords',
					name: 'keywords',
					content: `${this.seoData.gameName}游戏账号交易平台，${this.seoData.gameName}账号购买，${this.seoData.gameName}卖号平台，${this.seoData.gameName}买号平台，${this.seoData.gameName}账号选购平台，盼之代售游戏交易平台`
				}
			],
			script: [
				{
					hid: 'ldjson-schema',
					innerHTML: `{"@context": "https://ziyuan.baidu.com/contexts/cambrian.jsonid","@id":"https://${this.seoData.BAIDU_URL}","pubDate": "${this.seoData.BAIDU_PUSH_DATE}","upDate": "${this.seoData.BAIDU_DATE}"}`,
					type: 'application/ld+json'
				}
			],
			__dangerouslyDisableSanitizersByTagID: {
				'ldjson-schema': ['innerHTML']
			}
		}
	},
	activated() {
		abTrack()
	},
	destroyed() {
		this.$store.commit('game/SET_INDEX_RECOMMEND_FILTER', '')
		this.$store.commit('game/SET_INDEX_GAME_FILTER', {})
	}
}
